export const ChangeTypeAddition = 'A';
export const ChangeTypeDeletion = 'D';

export class MarketplaceAppDiffModel {
  appId: string;
  generalSettingsChanges: ChangedField[] = [];
  integrationChanges: ChangedField[] = [];
  endUserChanges: ChangedField[] = [];
  resellerChanges: ChangedField[] = [];
  orderFormChanges: ChangedField[] = [];
  dateChanged: Date;

  hasChanges(): boolean {
    let generalSettingsChanges;
    if (this.generalSettingsChanges) {
      // Don't count the version differences.
      generalSettingsChanges = this.generalSettingsChanges.filter((changeField) => {
        return changeField.fieldName.toLowerCase() !== 'version';
      });
    } else {
      generalSettingsChanges = this.generalSettingsChanges;
    }
    return !!(
      generalSettingsChanges.length ||
      this.integrationChanges.length ||
      this.endUserChanges.length ||
      this.resellerChanges.length ||
      this.orderFormChanges.length
    );
  }
}

export class ChangedField {
  fieldName: string;
  displayType: MpAppFieldDisplayType;
  oldValue: any;
  newValue: any;
  changeType: any;

  constructor(fieldName: string, displayType: MpAppFieldDisplayType, oldValue: any, newValue: any, changeType: string) {
    this.fieldName = fieldName;
    this.displayType = displayType;
    this.oldValue = oldValue;
    this.newValue = newValue;
    this.changeType = changeType;
  }
}

export enum MpAppFieldDisplayType {
  Text = 1,
  Money,
  Image,
  DateTime,
  Url,
  Email,
  File,
  Faq,
  OrderForm,
  CommonFormRequiredFields,
  lmiCategories,
  restrictions,
}
